@if (canInspect()) {
  <aside
    class="terminology-inspector"
    [class.terminology-inspector--active]="inspectionEnabled()"
    aria-label="Terminology inspection controls"
    data-testid="terminology-inspector">
    <button
      type="button"
      class="terminology-inspector__toggle"
      [attr.aria-pressed]="inspectionEnabled()"
      (click)="toggleInspection()">
      <span class="terminology-inspector__mark" aria-hidden="true">T</span>
      <span class="terminology-inspector__label">
        {{ inspectionEnabled() ? 'Terminology inspection' : 'Show editable wording' }}
      </span>
      @if (inspectionEnabled()) {
        <span class="terminology-inspector__count" aria-live="polite">
          {{ inspectionTargetCount() }} on page
        </span>
      }
    </button>

    @if (inspectionEnabled()) {
      <p>Right-click highlighted wording or select its <strong>T</strong> marker.</p>
    }
  </aside>
}

@if (inspectionEnabled()) {
  <div
    class="terminology-inspection-layer"
    data-testid="terminology-inspection-layer">
    @for (item of inspectionItems(); track item.id) {
      <span
        class="terminology-inspection-target"
        [class.terminology-inspection-target--compact]="item.compactOnly"
        [hidden]="!item.visible"
        [style.left.px]="item.left"
        [style.top.px]="item.top"
        [style.width.px]="item.width"
        [style.height.px]="item.height">
        <button
          type="button"
          tabindex="-1"
          class="terminology-inspection-target__marker"
          [attr.aria-label]="'Terminology actions for ' + item.displayText"
          [title]="item.displayText + ' — open terminology actions'"
          (click)="openInspectionTarget(item, $event)">
          T
        </button>
      </span>
    }
  </div>
}

@if (menuState(); as menu) {
  <section
    #menu
    class="terminology-context-menu"
    role="menu"
    [attr.aria-label]="'Terminology actions for ' + menu.displayText"
    [style.left.px]="menu.left"
    [style.top.px]="menu.top"
    (keydown)="onMenuKeydown($event)"
    data-testid="terminology-context-menu">
    <header class="terminology-context-menu__header">
      <div class="terminology-context-menu__context">
        <span>Terminology</span>
        <code [title]="menu.identity.tokenCode">{{ menu.identity.tokenCode }}</code>
      </div>
      <strong
        class="terminology-context-menu__label"
        data-testid="terminology-context-menu-label"
        [title]="menu.displayText">
        {{ menu.displayText }}
      </strong>
    </header>

    <div class="terminology-context-menu__actions">
      <button type="button" role="menuitem" (click)="openDetails()">
        <span>View details</span>
        <small>Current usage</small>
      </button>

      @if (canAuthor()) {
        <button type="button" role="menuitem" (click)="editWording()">
          <span>Edit wording</span>
          <small>Author workspace</small>
        </button>
      }

      <button type="button" role="menuitem" (click)="viewAllUsages()">
        <span>View all usages</span>
        <small>{{ menu.identity.configurationCode }}</small>
      </button>

      <button type="button" role="menuitem" (click)="copyToken()">
        <span>Copy token</span>
        <small>{{ copyStatus() ? 'Copied' : 'Reference' }}</small>
      </button>
    </div>

    <footer>
      <span>Menu key / Shift+F10</span>
      <span>Shift+right-click: browser</span>
    </footer>

    <p class="terminology-context-menu__status" aria-live="polite">
      {{ copyStatus() }}
    </p>
  </section>
}
